/* eslint-disable  no-unused-vars */
import Label from '@components/label';

import style from './textarea.module.scss';

const TextArea = ({
  label,
  required,
  errors,
  value,
  onChange,
  reconciled = false,
  placeholder,
  autoFocus = false
}) => {
  return (
    <div className={style.fieldInput}>
      <Label reconciled={reconciled} label={label} dot={required} error={errors.name} />

      <textarea
        value={value}
        rows={3}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`${style.inputField}   ${errors.name && style.errorBorder} `}
        autoFocus={autoFocus}
      />
    </div>
  );
};

export default TextArea;
